module.exports = __webpack_public_path__ + "img/pursuits_red.9fd01726.png";